import { Link } from 'react-router-dom';
import { Reveal } from '../components/ui';

interface MenuSplitData {
  eyebrow?: string;
  body?: string;
  primaryLabel?: string;
  primaryHref?: string;
  secondaryLabel?: string;
  secondaryHref?: string;
}

/** Centred statement with the two serif menu links, underlined gold and bronze. */
export function MenuSplitBlock({ data }: { data: MenuSplitData }) {
  return (
    <section className="sz-menu-split">
      <Reveal>
        {data.eyebrow && <p className="sz-eyebrow">{data.eyebrow}</p>}
        {data.body && <p className="sz-menu-split__body">{data.body}</p>}
        <div className="sz-menu-split__links">
          {data.primaryHref && (
            <Link to={data.primaryHref} className="sz-menu-split__link sz-menu-split__link--primary">
              {data.primaryLabel}
            </Link>
          )}
          {data.secondaryHref && (
            <Link to={data.secondaryHref} className="sz-menu-split__link">
              {data.secondaryLabel}
            </Link>
          )}
        </div>
      </Reveal>
    </section>
  );
}
